import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";
import { getBookingConfig } from "../../data/price";
import { setActivePromotion } from '../../stateReducers/deliverySlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { isWithinInterval, parseISO } from 'date-fns'
import Checkbox from './Checkbox';
import { promoIntervalRelevantToGunOptions } from '../../api/PromotionService';

interface PromoOptionProps{
}

/**
 * Use playStart for checking for delivery promotions - no need to check whole interval (decision by Martijn)
 */
const PromoOptions: FC<PromoOptionProps> = () => {
        const {t} = useTranslation();
        const d = useAppDispatch();
        const deliveryOptions = useAppSelector((state) => {
            return state.delivery;
        });
        const gunOptions = useAppSelector((state) => {
            return state.gunOptions;
        });
        const lang = useAppSelector((state) => {
            return state.globals.lang;
        });
        const extraSlice = useAppSelector((state) => {
            return state.extraItems;
        })

        const bookingConfig = getBookingConfig();

        // Finds the first promo interval that might fit
        const possiblePromoInterval = useMemo(() => {
            return bookingConfig.promoIntervals.find((interval) => {
                console.log("Checking interval", [interval]);
                console.log("Relevant?", promoIntervalRelevantToGunOptions(interval, gunOptions, extraSlice));
                // playStart must be defined, but it should already be
                return deliveryOptions.playStart
                    // The promo must apply to the user's language
                    && (interval.languages === undefined || interval.languages.includes(lang))
                    // playStart must be within the interval's range
                    && isWithinInterval(
                        deliveryOptions.playStart,
                        {
                            start: parseISO(interval.start),
                            end: parseISO(interval.end)
                        }
                    )
                    // The promo must apply to the customer's choice of guns (including quantity)
                    && (interval.promotion === undefined || promoIntervalRelevantToGunOptions(interval, gunOptions, extraSlice));
            })
        }, [deliveryOptions.playStart]);

        const activePromo = useAppSelector(state => state.delivery.activePromo);

        useEffect(() => {
            if (possiblePromoInterval === undefined) {
                d(setActivePromotion(""));
            } else if (possiblePromoInterval.name === activePromo) {
                // Nothing
            } else {
                setDisplayModal(true);
            }
        }, [possiblePromoInterval]);

        const labelText = () => {
            if (possiblePromoInterval) {
                return lang === "nl" ? possiblePromoInterval.description ?? "" : possiblePromoInterval.descriptionFr ?? "";
            } else {
                return "";
            }
        };

        const [displayModal, setDisplayModal] = useState<boolean>(true);
        const modalClassName = displayModal ? "modal-background" : "hidden";
        const [promoChecked, setPromoChecked] = useState<boolean>(false);

        useEffect(() => {
            if (!promoChecked) {
                d(setActivePromotion(""));
            } else {
                console.log("Possible promo", possiblePromoInterval);
                console.log("Promo name: " + possiblePromoInterval?.name ?? "");
                d(setActivePromotion(possiblePromoInterval?.name ?? ""));
            }
        }, [promoChecked, deliveryOptions.playStart]);

        return (
            <>
            {/* Modal box to pop up when a promo might be applicable */}
            <div className={modalClassName} onClick={() => setDisplayModal(false)}>
                <div className="promo-box">
                    {lang === "nl" && possiblePromoInterval?.bannerImgNl &&
                        <img className="promo-banner-img" src={possiblePromoInterval.bannerImgNl} alt="" />
                    }
                    {lang === "fr" && possiblePromoInterval?.bannerImgFr &&
                        <img className="promo-banner-img" src={possiblePromoInterval.bannerImgFr} alt="" />
                    }
                    <p dangerouslySetInnerHTML={{__html: labelText()}} />
                    <span
                        className='close close-green'
                        onClick={() => {
                            setDisplayModal(false);
                            setPromoChecked(true);
                        }}
                    >{t('promo.activateButton')}</span>
                    <span
                        className='close close-red'
                        onClick={() => {
                            setDisplayModal(false);
                            setPromoChecked(false);
                        }}
                    >{t('promo.notActivateButton')}</span>
                </div>
            </div>
            <div className="flex justify-between flex flex-col lg:flex-row mt-2">
                <Checkbox
                    checked={promoChecked}
                    label={'promoBox'}
                    labelText={labelText()}
                    onChange={() => { setPromoChecked(!promoChecked) }}
                    required={false}
                    redHighlight={false}
                    useLabelTextAsHtml={true}
                />
            </div>
            </>
        );
    }
;

export default PromoOptions;
